import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@mui/material'
import { CCard, CCardBody, CCardTitle } from '@coreui/react'
import styles from './accountcard.module.scss'
import { useTranslation } from 'react-i18next'

const AccountCard = ({ accountName, accountNumber, accountStatus, accountCreated }) => {
  const { t } = useTranslation('common')

  return (
    <CCard className={styles.clientCard}>
      <CCardTitle className={styles.cardTitle}>
        {accountName ? accountName : t('common.loading')}
      </CCardTitle>
      <CCardBody className={styles.cardBody}>
        <Chip
          key={accountNumber ? accountNumber : '000000000'}
          variant="filled"
          label={accountNumber ? accountNumber : '000000000'}
          className={styles.chipLayout}
        />
        <div className={styles.cardDetailsContainerDiv}>
          <div>
            <div className={styles.cardDetailsTitle}>{t('common.status')}</div>
            <div className={styles.cardBulletpointDetail}>
              <div
                className={
                  accountStatus === 'Active'
                    ? styles.columnmenustatusActive
                    : styles.columnmenustatusInactive
                }
              />
              {accountStatus ? accountStatus : t('common.notActive')}
            </div>
          </div>
          <div>
            <div className={styles.cardDetailsTitle}>
              {t('components.cards.account.dateJoined')}
            </div>
            <div className={styles.cardBulletpointDetail}>
              {accountCreated.isValid() ? accountCreated.format('DD-MM-YYYY') : '#'}
            </div>
          </div>
        </div>
      </CCardBody>
    </CCard>
  )
}

AccountCard.defaultProps = {
  accountName: '',
  accountNumber: '',
  accountStatus: '',
  accountCreated: {},
}

AccountCard.propTypes = {
  accountName: PropTypes.string,
  accountNumber: PropTypes.string,
  accountStatus: PropTypes.string,
  accountCreated: PropTypes.object,
}

export default AccountCard
